import { useGetEventSourceUpdatesQuery } from './eventSourceApi';

export const useEventSource = () => {
  // Use the RTK Query hook and pass the AbortController's instance
  const { data = [], isLoading, error } = useGetEventSourceUpdatesQuery(undefined, {
    pollingInterval: 0    // disable polling
  });

  return { events: data, status: (isLoading ? 'Connecting...' : (error ? 'Error - Reconnecting...' : 'Connected')) };
};